import React from 'react';
import { Printer, Download, Send, Truck, MapPin } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';

export const OrderSelectionBar = ({
    selectedCount,
    reportLoading,
    onReport,
    onShowMap,
    onDeselectAll,
}) => {
    if (selectedCount === 0) return null;

    return (
        <Card className="mb-4 border-amber-300 bg-amber-50">
            <CardContent className="py-3 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <span className="text-sm font-medium text-amber-800" data-testid="selected-count">
                    {selectedCount} commande(s) selectionnee(s)
                </span>
                <div className="flex flex-wrap gap-2">
                    <Button
                        size="sm"
                        className="bg-jungle hover:bg-jungle/90 text-white rounded-xl"
                        onClick={() => onReport('stock')}
                        disabled={reportLoading}
                        data-testid="report-stock-btn"
                    >
                        <Printer className="h-4 w-4 mr-1" />
                        Preparation commande
                    </Button>
                    <Button
                        size="sm"
                        variant="outline"
                        className="border-jungle text-jungle rounded-xl"
                        onClick={() => onReport('stock_pdf')}
                        disabled={reportLoading}
                        data-testid="report-stock-pdf-btn"
                    >
                        <Download className="h-4 w-4 mr-1" />
                        Preparation commande
                    </Button>
                    <Button
                        size="sm"
                        variant="outline"
                        className="border-blue-400 text-blue-600 rounded-xl"
                        onClick={() => onReport('stock_email')}
                        disabled={reportLoading}
                        data-testid="report-stock-email-btn"
                    >
                        <Send className="h-4 w-4 mr-1" />
                        Preparation commande
                    </Button>
                    <Button
                        size="sm"
                        className="bg-leaf hover:bg-leaf/90 text-white rounded-xl"
                        onClick={() => onReport('delivery')}
                        disabled={reportLoading}
                        data-testid="report-delivery-btn"
                    >
                        <Truck className="h-4 w-4 mr-1" />
                        Tournee Livraison
                    </Button>
                    <Button
                        size="sm"
                        variant="outline"
                        className="border-amber-300 text-amber-700 rounded-xl"
                        onClick={onDeselectAll}
                    >
                        Deselectionner tout
                    </Button>
                    <Button
                        size="sm"
                        variant="outline"
                        className="border-jungle text-jungle rounded-xl"
                        onClick={onShowMap}
                        data-testid="show-map-btn"
                    >
                        <MapPin className="h-4 w-4 mr-1" />
                        Carte livraison
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};
